<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.add') }} {{ $tc('message.professions', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-container>
                    <b-form  @reset="onReset" v-if="show">
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="nom-group"
                                        :label="$t('message.name')"
                                        label-for="nom"
                                        description=""
                                >
                                    <b-form-input
                                            id="nom"
                                            v-model="$v.form.nom.$model"
                                            :state="$v.form.nom.$dirty ? !(errorshasField('name') || $v.form.nom.$error) : null"
                                            required
                                            placeholder=""
                                            @focus="clearErrorField('name')"
                                    ></b-form-input>

                                    <b-form-invalid-feedback v-if="!$v.form.nom.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.nom.minLength">
                                        {{ $t('message.minCharacters', { n: 3 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-else-if="errorshasField('name')">
                                        {{ getErrorsField('name') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <b-button @click="onSubmit" variant="primary">
                                {{ $t('message.save') }}
                            </b-button>

                        </b-row>
                    </b-form>
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required,minLength } from 'vuelidate/lib/validators';

    export default {
        name: "AddProfession",

        computed: {
            ...mapGetters(["errors",'hasAdminRole',
                'hasGestionnaireRole']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },

        },

        data() {
            return {
                form: {
                    nom: ''
                },
                show: true
            }
        },

        methods: {
            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        name: this.form.nom
                    };

                    let successMessage = this.$i18n.t('message.professionCreated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('createProfession', { args, errorMessages, successMessage })
                        .then(() => {
                            // Scroll to the top of the page
                            document.body.scrollTop = 0; // For Safari
                            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
                        });
                }
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                this.form.nom = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                nom: {
                    required,
                    minLength: minLength(3)

                }
            }
        },

        mounted() {
            //
        }
    }
</script>

<style scoped>

</style>